var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pageBox" },
        [
          _c(
            "div",
            { staticClass: "breadcrumb" },
            [
              _c(
                "el-breadcrumb",
                { attrs: { separator: "/" } },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v("首页"),
                  ]),
                  _vm._v(" "),
                  _c("el-breadcrumb-item", [_vm._v("任务管理")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pageSerch" },
            [
              _c(
                "el-card",
                { staticClass: "box-card", attrs: { shadow: "never" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("span", { staticClass: "cardTitle" }, [
                        _vm._v("派单列表"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    { ref: "ruleForm", attrs: { model: _vm.ruleForm } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "姓名" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      maxlength: "50",
                                      clearable: "",
                                      placeholder: "请输入姓名",
                                    },
                                    model: {
                                      value: _vm.ruleForm.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "name", $$v)
                                      },
                                      expression: "ruleForm.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "地区" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { "margin-right": "auto" },
                                      attrs: { placeholder: "请选择地区" },
                                      model: {
                                        value: _vm.ruleForm.wxVerifiedStatus,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "wxVerifiedStatus",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.wxVerifiedStatus",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "已认证", value: "1" },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: { label: "未认证", value: "0" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "状态" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { "margin-right": "auto" },
                                      attrs: { placeholder: "请选择微信状态" },
                                      model: {
                                        value: _vm.ruleForm.cadeVerifyStatus,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "cadeVerifyStatus",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.cadeVerifyStatus",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "所有", value: "0" },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: { label: "待发布", value: "1" },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: { label: "发布中", value: "2" },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: { label: "待实做", value: "3" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "认证状态" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { "margin-right": "auto" },
                                      attrs: { placeholder: "请选择认证状态" },
                                      model: {
                                        value: _vm.ruleForm.status,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.ruleForm, "status", $$v)
                                        },
                                        expression: "ruleForm.status",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: "身份认证",
                                          value: "1",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-option", {
                                        attrs: { label: "未认证", value: "0" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "btn",
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.getList()
                                        },
                                      },
                                    },
                                    [_vm._v("查询")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.resetForm()
                                        },
                                      },
                                    },
                                    [_vm._v("重置")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pageTab" },
            [
              _c(
                "div",
                { staticClass: "titleBox" },
                [
                  _vm._l(_vm.regulationData, function (item, index) {
                    return item.type == 1
                      ? _c("div", { key: index }, [
                          _vm._v("\n          显示结束时间："),
                          _c("span", { staticStyle: { color: "#000" } }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("maxTime")(
                                  item.dispatchRule.dispatchEndTimeValue
                                )
                              )
                            ),
                          ]),
                        ])
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "indexBtn",
                      staticStyle: { "margin-left": "24px" },
                      on: { click: _vm.goViolation },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("../../assets/imgs/setting.png"),
                          alt: "",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", [_vm._v("设置规则")]),
                    ]
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  ref: "scrollTable",
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.tableData },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "creatorName",
                      label: "客户",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "title",
                      label: "任务名称",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "area", label: "区域", align: "center" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "要求人数", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(scope.row.readiesNum) +
                                  "/" +
                                  _vm._s(scope.row.membersNum)
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "距离结束时间", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              {
                                class: [
                                  scope.row.selectTime < 0 ? "redColor" : "",
                                ],
                              },
                              [
                                scope.row.selectTime < 0
                                  ? _c("span", [_vm._v("-")])
                                  : _vm._e(),
                                scope.row.day > 0
                                  ? _c("span", [
                                      _vm._v(_vm._s(scope.row.day) + "天"),
                                    ])
                                  : _vm._e(),
                                scope.row.hour1 > 0
                                  ? _c("span", [
                                      _vm._v(_vm._s(scope.row.hour1) + "小时"),
                                    ])
                                  : _vm._e(),
                                scope.row.middle > 0
                                  ? _c("span", [
                                      _vm._v(_vm._s(scope.row.middle) + "分"),
                                    ])
                                  : _vm._e(),
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.theTime) + "秒"),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "总金额", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                "￥" +
                                  _vm._s(_vm._f("moneyFormat")(scope.row.price))
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "加价", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                "￥" +
                                  _vm._s(
                                    _vm._f("moneyFormat")(scope.row.markUp)
                                  )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", align: "center", fixed: "right" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticClass: "disAround" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "operateBtn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.goDetail(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("查看")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "operateBtn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleEdit(scope.row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                派单\n              "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.pageSize,
                  layout: "total, prev, pager, next,sizes",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "派单设置",
                visible: _vm.dialogFormVisible1,
                width: "800px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogFormVisible1 = $event
                },
              },
            },
            [
              _c(
                "el-form",
                { ref: "ruleForm", attrs: { model: _vm.ruleForm2 } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 4 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入名称" },
                                on: { focus: _vm.clearData },
                                model: {
                                  value: _vm.ruleForm2.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm2, "name", $$v)
                                  },
                                  expression: "ruleForm2.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入手机号" },
                                on: { focus: _vm.clearData },
                                model: {
                                  value: _vm.ruleForm2.phone,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm2, "phone", $$v)
                                  },
                                  expression: "ruleForm2.phone",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "身份状态" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  model: {
                                    value: _vm.ruleForm2.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm2, "status", $$v)
                                    },
                                    expression: "ruleForm2.status",
                                  },
                                },
                                _vm._l(_vm.tableData2, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "btn",
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.getUserList(
                                        _vm.allocationJobNo
                                      )
                                    },
                                  },
                                },
                                [_vm._v("查询")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.resetForm1()
                                    },
                                  },
                                },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
                _vm._v("搜索总数：" + _vm._s(_vm.tableData1.length)),
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  ref: "singleTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tableData1,
                    "highlight-current-row": "",
                    "max-height": "250",
                  },
                  on: { "current-change": _vm.selectItem },
                },
                [
                  _c("el-table-column", {
                    attrs: { align: "center", width: "50" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", {
                              class: [
                                scope.row.id == _vm.selectUserId
                                  ? "select"
                                  : "noselect",
                              ],
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "姓名" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                scope.row.accountType == 0
                                  ? scope.row.companyName
                                  : scope.row.cardName
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "类型" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                scope.row.accountType == 0
                                  ? "企业"
                                  : scope.row.accountType == 0
                                  ? "企业员工"
                                  : "临勤"
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: { "margin-top": "30px", "text-align": "right" },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.allocation()
                        },
                      },
                    },
                    [_vm._v("派单")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.resetForm2()
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }